import { useEffect, useState } from "react";
import { IMapLocationTracker } from "../types";
import { coordsLatLngToBgs, IOsGridRef, toOSGridRef } from "../../MapComponents/geoUtils";


export interface LocationInfoProps {
    locationTracker: IMapLocationTracker;
}

const useLocationInfo = (props: LocationInfoProps) => {

    const [date, setDate] = useState<Date>(new Date());
    const [osGridRef, setOsGridRef] = useState<IOsGridRef | null>(null);

    useEffect(() => {
        const interval = setInterval(() => setDate(new Date()), 1000);
        return () => {
          clearInterval(interval);
        };
    }, []);

    useEffect(() => {
        setOsGridRef(!!props.locationTracker.location?.point ? toOSGridRef(coordsLatLngToBgs(props.locationTracker.location.point)) : null);
    }, [props.locationTracker.location])

    return {
        location: props.locationTracker.location,
        hasLocation: !!props.locationTracker.location,
        osGridRef,
        date
    };

};

export default useLocationInfo;